// eslint-disable-next-line @typescript-eslint/naming-convention
const ModalErrorState = {
	INACTIVE: 0,
	RETRIEVE_DASHBOARDS: 1,
	RETRIEVE_JWT: 2,
	RETRIEVE_JWT_INSTANCE_ID: 3
} as const;

type ModalErrorStateType = (typeof ModalErrorState)[keyof typeof ModalErrorState];

// eslint-disable-next-line @typescript-eslint/naming-convention
const ModalDashboardPreviewState = {
	INACTIVE: 0,
	OVERVIEW: 1,
	CAROUSEL: 2
} as const;

type ModalDashboardPreviewStateType = (typeof ModalDashboardPreviewState)[keyof typeof ModalDashboardPreviewState];

interface IModalManager {
	open: (modal: any) => void;
	close: (modal: any) => void;
}

export { ModalErrorState, ModalErrorStateType, ModalDashboardPreviewState, ModalDashboardPreviewStateType, IModalManager };
